import { render } from "./AddOwner.vue?vue&type=template&id=c816660c"
import script from "./AddOwner.vue?vue&type=script&lang=js"
export * from "./AddOwner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__